import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

import { Subscription } from 'rxjs';
import * as vaultSelector from '../../../../../root-store/vault-store/vault.selector';

@AutoUnsubscribe()
@Component({
  selector: 'add-performance-summary',
  templateUrl: './add-performance-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddPerformanceSummaryComponent implements OnInit {
  @Input() mode;
  @Input() name;
  @Input() data;
  @Input() currentuserId;
  @Input() currentFormId;
  @Input() isRemoveEditSaveSharing;
  @Input() fId;
  @Input() currentValutUserId;

  tvpi;
  isLoading = true;
  has_tvpi = false;
  subscription = new Subscription();

  constructor(
    private store: Store,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {}
}
